import React from 'react'
import { numberFormatter } from '../../helper';

const TableSakinah = ({ dataTable = [] }) => {
    
    return (
        <div className="w-full sm:overflow-visible overflow-x-auto flex flex-col justify-center">
            <table className="w-full lg:w-3/4 table-auto text-xs mb-4 mx-auto">
                <thead className="bg-primeColor1 text-white sticky top-0">
                    <tr>
                        <th className="border border-slate-500  w-[1%]" rowSpan={2}>
                            No
                        </th>
                        <th className="border border-slate-500 md:w-2/5" rowSpan={2}>
                            Sasaran
                        </th>
                        <th className="border border-slate-500 w-[30%]" rowSpan={2}>
                            Indikator
                        </th>
                        <th className="border border-slate-500 md:w-[5%]" rowSpan={2}>
                            Satuan
                        </th>
                        <th className="border border-slate-500" colSpan={3}>
                            <span>Capaian Perjanjian Kinerja Gubernur</span>
                        </th>
                        {
                            // triwulan.map((item, index) => {
                            //     return (
                            //         <th className="border border-slate-500" colSpan={3} key={index}>
                            //             <span>{`Triwulan ${index+1}`}</span>
                            //         </th>
                            //     )
                            // })
                        }
                    </tr>
                    <tr>
                        <th className="border border-slate-500">
                            <span className='hidden md:inline'>Target</span>
                            <span className='inline md:hidden'>T</span>
                        </th>
                        <th className="border border-slate-500">
                            <span className='hidden md:inline'>Realisasi</span>
                            <span className='inline md:hidden'>R</span>
                        </th>
                        <th className="border border-slate-500">
                            <span className='hidden md:inline'>Capaian</span>
                            <span className='inline md:hidden'>C</span>
                        </th>
                        {
                            // triwulan.map((item, index) => {
                            //     return (
                            //         <>
                            //             <th className="border border-slate-500" key={index}>
                            //                 <span className='hidden md:inline'>Target</span>
                            //                 <span className='inline md:hidden'>T</span>
                            //             </th>
                            //             <th className="border border-slate-500" key={index}>
                            //                 <span className='hidden md:inline'>Realisasi</span>
                            //                 <span className='inline md:hidden'>R</span>
                            //             </th>
                            //             <th className="border border-slate-500" key={index}>
                            //                 <span className='hidden md:inline'>Capaian</span>
                            //                 <span className='inline md:hidden'>C</span>
                            //             </th>
                            //         </>
                            //     )
                            // })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        dataTable ? dataTable.map((item, index) => {
                            return (
                                <>
                                    {item.indikator.map((indikator, indIndex) => (
                                        <tr className={`odd:bg-primeColor2 ${indIndex === item.indikator.length - 1 ? 'border-b-2 border-red-500' : ''}`} key={indIndex}>
                                            {indIndex === 0 && (
                                                <>
                                                    <td className="border border-slate-500 bg-secondaryColor2 p-2 text-right align-top" rowSpan={item.indikator.length}>{index + 1}</td>
                                                    <td className="border border-slate-500 bg-secondaryColor2 p-2 align-top" rowSpan={item.indikator.length}>{item.sasaran}</td>
                                                </>
                                            )}
                                            <td className="border border-slate-500 p-2">{indikator.indikator}</td>
                                            <td className="border border-slate-500 p-2 text-center">{indikator.satuan ?? ''}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.target_tw4 ? numberFormatter(indikator.target_tw4) : ""}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.realisasi_tw4 ? numberFormatter(indikator.realisasi_tw4) : ""}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.capaian_tw4 ? numberFormatter(indikator.capaian_tw4) : ""}</td>
                                        </tr>
                                    ))}
                                </>
                            );
                        }) :
                        <tr>
                            <td className="border border-slate-500 py-2 px-5 bg-green-200" colSpan="100%">Loading...</td>
                        </tr>
                    }
            
                </tbody>
            </table>
            <div className="w-full px-3">
                <div className="w-3/4 mx-auto">
                    <span className="text-red-400 text-xs font-bold">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; *) Sumber data : Perjanjian Kinerja Gubernur pada Aplikasi Sakinah
                    </span>
                </div>
            </div>
        </div>
    )
}

export default TableSakinah